import BaseReportComponent from '@/report/components/BaseReportComponent';
import { computed, ComputedRef, defineComponent } from 'vue';
import { useStore } from 'vuex';
import { CtaExtendedReportData } from '../models/CtaExtendedReportData';
import CtaSunburstChartVue from '../components/CtaSunburstChart.vue';
import CoverPageVue from '../components/CoverPage.vue';
import HtmlHelper from '@/generic/helpers/HtmlHelper';
import ReportWrapperVue from '@/report/components/ReportWrapper.vue';

export default defineComponent({
    extends: BaseReportComponent,
    components: {
        ReportWrapperVue,
        CtaSunburstChart: CtaSunburstChartVue,
        CoverPage: CoverPageVue,
    },
    setup() {
        const store = useStore();
        const dateCompleted: ComputedRef<string> = computed(() => {
            const date = new Date(reportData.value.dateCompleted);
            return date.toLocaleDateString(undefined, {
                year: 'numeric' as const,
                month: 'numeric' as const,
                day: 'numeric' as const,
            });
        });
        const reportData: ComputedRef<CtaExtendedReportData> = computed(() => store.getters['report/report']);
        const generalArray: ComputedRef<Record<string, number>> = computed(() => ({
            actionMove: reportData.value.actionMove,
            actionFollow: reportData.value.actionFollow,
            actionOppose: reportData.value.actionOppose,
            actionBystand: reportData.value.actionBystand,
            operatingOpen: reportData.value.operatingOpen,
            operatingClosed: reportData.value.operatingClosed,
            operatingRandom: reportData.value.operatingRandom,
            attentionAffect: reportData.value.attentionAffect,
            attentionMeaning: reportData.value.attentionMeaning,
            attentionPower: reportData.value.attentionPower,
        }));

        const actionDomainArray: ComputedRef<Record<string, number>> = computed(() => ({
            actionMove: reportData.value.actionMove,
            actionFollow: reportData.value.actionFollow,
            actionOppose: reportData.value.actionOppose,
            actionBystand: reportData.value.actionBystand,
        }));

        const operatingDomainArray: ComputedRef<Record<string, number>> = computed(() => ({
            operatingOpen: reportData.value.operatingOpen,
            operatingClosed: reportData.value.operatingClosed,
            operatingRandom: reportData.value.operatingRandom,
        }));

        const attentionDomainArray: ComputedRef<Record<string, number>> = computed(() => ({
            attentionAffect: reportData.value.attentionAffect,
            attentionMeaning: reportData.value.attentionMeaning,
            attentionPower: reportData.value.attentionPower,
        }));

        const profileKey = computed(() => {
            return `${reportData.value.actionPreferred.toUpperCase()}_${reportData.value.operatingPreferred.toUpperCase()}_${reportData.value.attentionPreferred.toUpperCase()}`;
        });

        return {
            reportData,
            profileKey,
            generalArray,
            dateCompleted,
            actionDomainArray,
            operatingDomainArray,
            attentionDomainArray,
            sanitizeHtml: HtmlHelper.sanitizeHtml,
        };
    },
});
